<template>
    <el-row class="header">
        <div
            @click="layoutChange()"
            :class="['layout-trigger', 'icon', this.layoutClass]"
        ></div>
        <el-col :span="4" class="header-block">
            <div class="grid-content text-left">
                <img src="@/assets/pvh-24.png" class="logo" alt="logo" @click="goTasks">
            </div>
        </el-col>
        <search />
        <el-col :span="6" class="header-right-side">
            <div class="grid-content text-right">
                <div class="avatar">
                    <font-awesome-icon icon="user-circle" class="grey2 avatar-icon" />
                </div>
                <div class="info">
                    <span class="name">
                        {{ name }}
                    </span>
                    <a class="logout" href="#" @click="logout">
                        выход
                    </a>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import Search from '@/components/search/Search';

library.add(faUserCircle);

export default {
    name: 'Header',
    components: { Search },
    data() {
        return {
            layoutIsMobile: null
        };
    },
    computed: {
        name() {
            return this.$store.state.auth.name;
        },
        cookie() {
            return document.cookie.split('; ').reduce((prev, current) => {
                const [name, value] = current.split('=');
                prev[name] = value;
                return prev;
            }, {});
        },
        layoutClass() {
            return this.layoutIsMobile ? 'icon-desktop' : 'icon-mobile';
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout').then(
                response => {
                    this.$router.push('/login');
                    this.$store.commit('preferences/clearStore');
                    this.$store.commit('employers/clearStore');
                },
                error => {
                    console.log(error);
                }
            );
        },
        goTasks() {
            this.$router.push({ name: 'tasks-all' });
        },
        layoutChange() {
            this.layoutIsMobile = !this.layoutIsMobile;
            document.cookie = 'isMobile' + '=' + this.layoutIsMobile;
            location.reload();
        }
    },
    mounted() {
        const cookies = this.cookie;
        if (Object.prototype.hasOwnProperty.call(cookies, 'isMobile')) {
            this.layoutIsMobile = JSON.parse(cookies.isMobile);
        } else {
            document.cookie = 'isMobile=true';
        }
    }
};
</script>
